import type { IterableLike } from "../types/IterableLike"
import { RecordCreate } from "@pdfking/tfunc"
import { to_array } from "./to_array"

/**
 * Creates object from iterable of [key, value] pairs.
 *
 * Later duplicate keys override earlier ones.
 *
 * @param iterable - Iterable of [key, value] pairs (default: [])
 * @returns Object
 *
 * @example
 * ```ts
 * import { ordered_object } from "@pdfking/rfunc"
 *
 * ordered_object([["a", 2], ["b", 3]]) // { a: 2, b: 3 }
 * ordered_object([["z", 2], ["b", 3], ["b", 4]]) // { z: 2, b: 4 }
 * ```
 */
export const ordered_object = <K extends PropertyKey, V>(
  iterable: IterableLike<[K, V]> = []
): { [P in K]: V } =>
  RecordCreate(to_array(iterable) as Iterable<readonly [K, V]>) as {
    [P in K]: V
  }
